export default [
    {
        type: "Menu"
    },
    {
        type: "TrayBar"
    },
    {
        type: "Desktop"
    },
    {
        type: "RunnedApps"
    },
    {
        type: "TasksBg"
    },
    {
        type: "Notification"
    },
    {
        type: "ReportBg"
    },
    {
        type: "UserProfile"
    },
    {
        type: "AuthWatcher"
    },
    {
        type: "ExpiredTokenWatcher"
    },
    {
        type: "DynamicJournalBg"
    }
];
